import { AppNS } from 'app';
import { can } from 'app/helpers/can';
import { getUserRoleInfo } from 'app/ui_v2/helpers/users';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Box, Tab, Tabs } from '@mui/material';

import { PROFILE_TABS, PROFILE_TABS_TO_CHECK_INSPECTORS_PERMISSION } from '../../config';

const canUserViewTab = (tab: (typeof PROFILE_TABS)[number], currentUser: AppNS.User, companyId: string) => {
  // additional checks for specific tabs
  const tabToCheck = PROFILE_TABS_TO_CHECK_INSPECTORS_PERMISSION.find((t) => t.id === tab.slug);
  if (tabToCheck) {
    return tabToCheck.permissions.some((permission) => can(currentUser, permission, companyId));
  }
  return true;
};

const getTabs = (isAdmin: boolean, currentUser: AppNS.User, companyId: string) => {
  let viewAs: 'agency' | 'admin' = 'agency';
  if (isAdmin) {
    viewAs = 'admin';
    return PROFILE_TABS.filter((v) => v.visibleFor.length > 0 && v.visibleFor.includes(viewAs));
  }
  // additional check
  return PROFILE_TABS.filter(
    (v) => v.visibleFor.length > 0 && v.visibleFor.includes(viewAs) && canUserViewTab(v, currentUser, companyId)
  );
};

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export interface LayoutTabsProps {
  companyId: string;
}

export default function LayoutTabs(props: LayoutTabsProps) {
  const { companyId } = props;
  const { pathname } = useLocation();

  const { isAdmin, currentUser } = getUserRoleInfo();

  const [value, setValue] = useState<number>(0);
  const navigate = useNavigate();

  console.log(currentUser);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    navigate(
      PROFILE_TABS.find((item) => {
        return item.index === newValue;
      })?.slug || 'main'
    );
  };

  useEffect(() => {
    const currentTab = PROFILE_TABS.find((item) => pathname.includes(item.slug));
    if (currentTab) {
      setValue(currentTab.index);
    }
  }, [pathname]);

  const tabs = getTabs(isAdmin, currentUser, companyId);

  if (tabs.length <= 1) {
    return null;
  }

  return (
    <>
      <Box pb={3}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons={false}
          aria-label="Agency profile Tabs"
        >
          {tabs.map((item) => (
            <Tab
              key={item.index}
              value={item.index}
              label={item.name}
              disabled={item.disabled}
              {...a11yProps(item.index)}
              sx={{ textTransform: 'uppercase' }}
              onClick={() => {
                if (item.index === value) {
                  navigate(item.slug);
                }
              }}
            />
          ))}
        </Tabs>
      </Box>
    </>
  );
}
